import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import clsx from "clsx";
import type React from "react";

interface Props {
	children: React.ReactNode;
	name: string;
	value: string;
	checked?: boolean;
	status?: boolean;
	onChange?: (value: string) => void;
}

const RadioSubscription: React.FC<Props> = ({
	children,
	name,
	value,
	checked,
	status,
	onChange,
}) => {
	const handleClick = () => {
		if (!status && onChange) {
			onChange(value);
		}
	};

	return (
		<>
			{/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
			<div
				className={clsx(
					"btn-subscription",
					{ active: checked },
					{
						"grayscale opacity-50 cursor-not-allowed": status,
						"cursor-pointer": !status,
					},
					"mx-auto",
				)}
				onClick={handleClick}
			>
				<input
					type="radio"
					name={name}
					value={value}
					disabled={status}
					checked={checked}
					onChange={() => {}}
					style={{ display: "none" }}
					aria-label="radio"
				/>
				{children}
				{checked && (
					<CheckCircleRoundedIcon className="absolute top-2 right-3 text-primary" />
				)}
			</div>
		</>
	);
};

export default RadioSubscription;
